// extracted by mini-css-extract-plugin
module.exports = {"title":"SubjectTable_title__Wqr1o","description":"SubjectTable_description__XsAn9","topicContainer":"SubjectTable_topicContainer__B4PsB"};